import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const relatedLinks = [
  {
    to: "/yokohama",
    label: "横浜ヘリクルージング",
    desc: "コース・料金・景色を詳しく",
    icon: "ri-compass-3-line",
  },
  {
    to: "/gift",
    label: "ギフトチケット",
    desc: "大切な人へ特別な体験を贈る",
    icon: "ri-gift-fill",
  },
  {
    to: "/contact",
    label: "お問い合わせ",
    desc: "ご質問・ご予約はこちら",
    icon: "ri-mail-line",
  },
];

export default function InfoPageFooter() {
  return (
    <section className="py-16 md:py-20 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-8 md:mb-10">
              <p className="section-label mb-2">RELATED</p>
              <h2 className="section-title">他のページもご覧ください</h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {relatedLinks.map((link, idx) => (
              <ScrollReveal key={link.to} direction="up" delay={idx * 80}>
                <Link
                  to={link.to}
                  className="group flex flex-col items-center text-center bg-white rounded-lg p-6 md:p-7 border border-airdoa-gray-light/30 h-full transition-all duration-300 hover:border-airdoa-gold/50"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-3 transition-colors group-hover:bg-airdoa-gold group-hover:text-airdoa-navy">
                    <i className={`${link.icon} text-lg`} />
                  </div>
                  <h3 className="text-sm font-serif font-semibold text-airdoa-navy group-hover:text-airdoa-gold transition-colors">
                    {link.label}
                  </h3>
                  <p className="mt-1 text-xs text-airdoa-gray">{link.desc}</p>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}